import { render } from "./knowledge.vue?vue&type=template&id=5406f084"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/knowledge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5406f084"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5406f084', __exports__)) {
    api.reload('5406f084', __exports__)
  }
  
  module.hot.accept("./knowledge.vue?vue&type=template&id=5406f084", () => {
    api.rerender('5406f084', render)
  })

}


export default __exports__